import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import ArraySnippetPicker from 'components/organisms/late-swap/services/array-snippet-picker';

export const contestIdsSnippetMap = {
    draftkings(): ArraySnippetInterface {
        const startColumnNumber: number = 2;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    fanduel(): ArraySnippetInterface {
        const startColumnNumber: number = 1;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    yahoo(): ArraySnippetInterface {
        const startColumnNumber: number = 3;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
};

export const contestNamesSnippetMap = {
    draftkings(): ArraySnippetInterface {
        const startColumnNumber: number = 1;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    fanduel(): ArraySnippetInterface {
        const startColumnNumber: number = 2;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    yahoo(): ArraySnippetInterface {
        const startColumnNumber: number = 0;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
};

export const entryIdsSnippetMap = {
    draftkings(): ArraySnippetInterface {
        const startColumnNumber: number = 0;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    fanduel(): ArraySnippetInterface {
        const startColumnNumber: number = 0;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    yahoo(): ArraySnippetInterface {
        const startColumnNumber: number = 4;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 1;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
};

export const lineupDetailsSnippetMap = {
    draftkings(): ArraySnippetInterface {
        const startColumnNumber: number = 0;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 4;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    fanduel(): ArraySnippetInterface {
        const startColumnNumber: number = 0;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 4;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
    yahoo(): ArraySnippetInterface {
        const startColumnNumber: number = 0;
        const startRowNumber: number = 1;
        const columnsQuantity: number = 5;

        return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
    },
};

export const lineupPlayersSnippetMap = {
    draftkings: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 8;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 10;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 8;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
    fanduel: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 7;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
    yahoo: {
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 5;
                const startRowNumber: number = 1;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
};

export const lineupsSnippetMap = {
    draftkings: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 12;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 14;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 12;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 13;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
    fanduel: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 11;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 13;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 13;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 13;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
    yahoo: {
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 0;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 14;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
};

export const playersSnippetMap = {
    draftkings: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 13;
                const startRowNumber: number = 7;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 15;
                const startRowNumber: number = 7;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 13;
                const startRowNumber: number = 7;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 14;
                const startRowNumber: number = 7;
                const columnsQuantity: number = 9;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
    fanduel: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 12;
                const startRowNumber: number = 6;
                const columnsQuantity: number = 14;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 14;
                const startRowNumber: number = 6;
                const columnsQuantity: number = 18;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 14;
                const startRowNumber: number = 6;
                const columnsQuantity: number = 14;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 14;
                const startRowNumber: number = 6;
                const columnsQuantity: number = 14;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
            },
        },
    },
    yahoo: {
        nfl: {
            classic(): ArraySnippetInterface {
                function getPlayersHeaderSnippet() {
                    const startColumnNumber: number = 16;
                    const startRowNumber: number = 0;
                    const columnsQuantity: number = 13;
                    const rowsQuantity: number = 1;

                    return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
                }

                function getPlayersSnippet() {
                    const startColumnNumber: number = 16;
                    const startRowNumber: number = 9;
                    const columnsQuantity: number = 13;

                    return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity);
                }

                return new ArraySnippetPicker([getPlayersHeaderSnippet(), getPlayersSnippet()]);
            },
        },
    },
};

export const positionsSnippetMap = {
    draftkings: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 8;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 10;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 8;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 9;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
    },
    fanduel: {
        cfb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 7;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
        mlb: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 9;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
        nba: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 9;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 4;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 9;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
    },
    yahoo: {
        nfl: {
            classic(): ArraySnippetInterface {
                const startColumnNumber: number = 5;
                const startRowNumber: number = 0;
                const columnsQuantity: number = 9;
                const rowsQuantity: number = 1;

                return new ArraySnippet(startColumnNumber, startRowNumber, columnsQuantity, rowsQuantity);
            },
        },
    },
};

export const lineupsValidationCriteriaMap = {
    draftkings: {
        cfb: {
            headerFormat: [
                'Entry ID',
                'Contest Name',
                'Contest ID',
                'Entry Fee',
                'QB',
                'RB',
                'RB',
                'WR',
                'WR',
                'WR',
                'FLEX',
                'S-FLEX',
            ],
        },
        mlb: {
            headerFormat: [
                'Entry ID',
                'Contest Name',
                'Contest ID',
                'Entry Fee',
                'P',
                'P',
                'C',
                '1B',
                '2B',
                '3B',
                'SS',
                'OF',
                'OF',
                'OF',
            ],
        },
        nba: {
            headerFormat: [
                'Entry ID',
                'Contest Name',
                'Contest ID',
                'Entry Fee',
                'PG',
                'SG',
                'SF',
                'PF',
                'C',
                'G',
                'F',
                'UTIL',
            ],
        },
        nfl: {
            headerFormat: [
                'Entry ID',
                'Contest Name',
                'Contest ID',
                'Entry Fee',
                'QB',
                'RB',
                'RB',
                'WR',
                'WR',
                'WR',
                'TE',
                'FLEX',
                'DST',
            ],
        },
    },
    fanduel: {
        cfb: {
            headerFormat: [
                'entry_id',
                'contest_id',
                'contest_name',
                'entry_fee',
                'QB',
                'RB',
                'RB',
                'WR',
                'WR',
                'WR',
                'Super FLEX',
            ],
        },
        mlb: {
            headerFormat: [
                'entry_id',
                'contest_id',
                'contest_name',
                'entry_fee',
                'P',
                'C/1B',
                '2B',
                '3B',
                'SS',
                'OF',
                'OF',
                'OF',
                'UTIL',
            ],
        },
        nba: {
            headerFormat: [
                'entry_id',
                'contest_id',
                'contest_name',
                'entry_fee',
                'PG',
                'SG',
                'SF',
                'PF',
                'C',
                'G/F',
                'F/C',
                'UTIL',
                'UTIL',
            ],
        },
        nfl: {
            headerFormat: [
                'entry_id',
                'contest_id',
                'contest_name',
                'entry_fee',
                'QB',
                'RB',
                'RB',
                'WR',
                'WR',
                'WR',
                'TE',
                'FLEX',
                'DEF',
            ],
        },
    },
    yahoo: {
        nfl: {
            headerFormat: [
                'Contest Title',
                'Entry Fee',
                'Prizes',
                'Contest ID',
                'Entry ID',
                'QB',
                'RB1',
                'RB2',
                'WR1',
                'WR2',
                'WR3',
                'TE',
                'FLEX',
                'DEF',
            ],
        },
    },
};

export const playersValidationCriteriaMap = {
    draftkings: {
        cfb: {
            headerFormat: [
                'Position',
                'Name + ID',
                'Name',
                'ID',
                'Roster Position',
                'Salary',
                'Game Info',
                'TeamAbbrev',
                'AvgPointsPerGame',
            ],
        },
        mlb: {
            headerFormat: [
                'Position',
                'Name + ID',
                'Name',
                'ID',
                'Roster Position',
                'Salary',
                'Game Info',
                'TeamAbbrev',
                'AvgPointsPerGame',
            ],
        },
        nba: {
            headerFormat: [
                'Position',
                'Name + ID',
                'Name',
                'ID',
                'Roster Position',
                'Salary',
                'Game Info',
                'TeamAbbrev',
                'AvgPointsPerGame',
            ],
        },
        nfl: {
            headerFormat: [
                'Position',
                'Name + ID',
                'Name',
                'ID',
                'Roster Position',
                'Salary',
                'Game Info',
                'TeamAbbrev',
                'AvgPointsPerGame',
            ],
        },
    },
    fanduel: {
        cfb: {
            headerFormat: [
                'Player ID + Player Name',
                'Id',
                'Position',
                'First Name',
                'Nickname',
                'Last Name',
                'FPPG',
                'Played',
                'Salary',
                'Game',
                'Team',
                'Opponent',
                'Injury Indicator',
                'Injury Details',
            ],
        },
        mlb: {
            headerFormat: [
                'Player ID + Player Name',
                'Id',
                'Position',
                'First Name',
                'Nickname',
                'Last Name',
                'FPPG',
                'Played',
                'Salary',
                'Game',
                'Team',
                'Opponent',
                'Injury Indicator',
                'Injury Details',
                'Tier',
                'Probable Pitcher',
                'Batting Order',
                'Roster Position',
            ],
        },
        nba: {
            headerFormat: [
                'Player ID + Player Name',
                'Id',
                'Position',
                'First Name',
                'Nickname',
                'Last Name',
                'FPPG',
                'Played',
                'Salary',
                'Game',
                'Team',
                'Opponent',
                'Injury Indicator',
                'Injury Details',
            ],
        },
        nfl: {
            headerFormat: [
                'Player ID + Player Name',
                'Id',
                'Position',
                'First Name',
                'Nickname',
                'Last Name',
                'FPPG',
                'Played',
                'Salary',
                'Game',
                'Team',
                'Opponent',
                'Injury Indicator',
                'Injury Details',
            ],
        },
    },
    yahoo: {
        nfl: {
            headerFormat: [
                'ID',
                'First Name',
                'Last Name',
                'ID + Name',
                'Position',
                'Team',
                'Opponent',
                'Game',
                'Time',
                'Salary',
                'FPPG',
                'Injury Status',
                'Starting',
            ],
        },
    },
};
